// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.button {
    padding: var(--space-half-quarter) var(--space-x3);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    font-weight: var(--font-medium);
    font-family: var(--secondary-font);
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));
    letter-spacing: 0.0025em;
    color: var(--white-color);
    border-radius: 6px;
    display: grid;
    justify-items: center;
    align-items: center;
    grid-template-columns: auto auto auto;
    grid-template-areas: "icon text void";
    /* grid-column-gap: var(--space-half); */
    width: fit-content;
    border: none;
    background-color: transparent;
    text-decoration: none !important;
    text-transform: capitalize;
}
.button img {
    max-height: var(--space);
    height: var(--space);
    max-width: var(--space);
    width: var(--space);
    grid-area: icon;
}
.button span{
    grid-area: text;    
    text-transform: lowercase;
    text-decoration: none;
}

.button span::first-letter{
    text-transform: uppercase;
}

.button:active, .button:focus {
    outline: none;
}
.button:hover {
    cursor: pointer;
}

/* .button.large {
    padding: var(--space) var(--space-x2);
    width: 100%;
} */
.button.small {
    padding: calc(var(--space-half) + var(--space-eighth)) calc(var(--space-x2) + var(--space-half) + var(--space-eighth));
    font-size: var(--space);/* 16px */
    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
}

.button.xs{
    padding: var(--space-half) calc(var(--space-half-quarter) + var(--space-half));
    font-size: calc(var(--space) - var(--space-eighth));/* 14px */
    line-height: var(--space) ;/* 16px */
}`, "",{"version":3,"sources":["webpack://./src/shared/components/button/ButtonComponent.styles.css"],"names":[],"mappings":";AACA;IACI,kDAAkD;IAClD,yDAAyD;IACzD,+BAA+B;IAC/B,kCAAkC;IAClC,4EAA4E;IAC5E,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qCAAqC;IACrC,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;IAChC,0BAA0B;AAC9B;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;;AAEA;;;GAGG;AACH;IACI,sHAAsH;IACtH,uBAAuB,CAAC,SAAS;IACjC,2DAA2D,CAAC,SAAS;AACzE;;AAEA;IACI,8EAA8E;IAC9E,mDAAmD,CAAC,SAAS;IAC7D,0BAA0B,CAAC,SAAS;AACxC","sourcesContent":["\n.button {\n    padding: var(--space-half-quarter) var(--space-x3);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    font-weight: var(--font-medium);\n    font-family: var(--secondary-font);\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));\n    letter-spacing: 0.0025em;\n    color: var(--white-color);\n    border-radius: 6px;\n    display: grid;\n    justify-items: center;\n    align-items: center;\n    grid-template-columns: auto auto auto;\n    grid-template-areas: \"icon text void\";\n    /* grid-column-gap: var(--space-half); */\n    width: fit-content;\n    border: none;\n    background-color: transparent;\n    text-decoration: none !important;\n    text-transform: capitalize;\n}\n.button img {\n    max-height: var(--space);\n    height: var(--space);\n    max-width: var(--space);\n    width: var(--space);\n    grid-area: icon;\n}\n.button span{\n    grid-area: text;    \n    text-transform: lowercase;\n    text-decoration: none;\n}\n\n.button span::first-letter{\n    text-transform: uppercase;\n}\n\n.button:active, .button:focus {\n    outline: none;\n}\n.button:hover {\n    cursor: pointer;\n}\n\n/* .button.large {\n    padding: var(--space) var(--space-x2);\n    width: 100%;\n} */\n.button.small {\n    padding: calc(var(--space-half) + var(--space-eighth)) calc(var(--space-x2) + var(--space-half) + var(--space-eighth));\n    font-size: var(--space);/* 16px */\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n}\n\n.button.xs{\n    padding: var(--space-half) calc(var(--space-half-quarter) + var(--space-half));\n    font-size: calc(var(--space) - var(--space-eighth));/* 14px */\n    line-height: var(--space) ;/* 16px */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
